module.exports = __webpack_public_path__ + "img/MES12Indice6.26050712.png";